import { Store } from '@tanstack/react-store';
import type { SortingState } from '@tanstack/react-table';
import { createManagementActions } from './createManagementStore';

export interface DappDetail {
  id: string;
  dappName: string;
  packageName: string | null;
  subtitle: string | null;
  description: string;
  dappIconUrl: string | null;
  dappIconThumbnailUrl: string | null;
  status: 'Draft' | 'UnderReview' | 'Published' | 'Rejected' | 'Archived';
  workflowStatus:
    | 'Draft'
    | 'UnderReview'
    | 'Published'
    | 'Rejected'
    | 'Archived';
  publishedVersionName: string | null;
  publishedVersionCode: number | null;
  contactEmail: string;
  supportEmail: string;
  appWebsite: string | null;
  walletAddress: string | null;
  tokenDistribution: boolean;
  nftMintAddress: string | null;
  importedFromNft: boolean | null;
  created: number;
  updated: number | null;
  publisherId: string;
  publisherType: 'Organization' | 'Individual';
  publisherName: string;
  publisherEmail: string | null;
  publisherWebsite: string;
  releaseCount: number;
  latestRelease: {
    id: string;
    versionName: string | null;
    versionCode: number | null;
    status: string;
    created: number;
  } | null;
  editorsChoice: {
    headline: string;
    tag: string | null;
    graphicUrl: string | null;
  } | null;
  users: Array<{
    id: string;
    email: string;
    fullName: string;
  }>;
}

export interface DappsPageState {
  dapps: DappDetail[];
  filters: {
    status:
      | 'all'
      | 'Draft'
      | 'UnderReview'
      | 'Published'
      | 'Rejected'
      | 'Archived';
    publisherType: 'all' | 'Organization' | 'Individual';
    hasNft: 'all' | 'true' | 'false';
    search: string;
  };
  sorting: SortingState;
  pagination: {
    currentPage: number;
    totalPages: number;
    total: number;
  };
  ui: {
    isLoading: boolean;
    selectedDappId: string | null;
  };
}

const initialFilters: DappsPageState['filters'] = {
  status: 'all',
  publisherType: 'all',
  hasNft: 'all',
  search: '',
};

const defaultSorting: SortingState = [{ id: 'created', desc: true }];

export const dappsPageStore = new Store<DappsPageState>({
  dapps: [],
  filters: initialFilters,
  sorting: defaultSorting,
  pagination: { currentPage: 1, totalPages: 1, total: 0 },
  ui: { isLoading: true, selectedDappId: null },
});

const actions = createManagementActions(dappsPageStore, {
  initialFilters,
  defaultSorting,
});

export const {
  updateFilter,
  setSorting,
  setPage,
  setPaginationInfo,
  setLoading,
  resetFilters,
} = actions;

export const setDappsQueryState = actions.setQueryState;

export const setDapps = (dapps: DappDetail[]) => {
  dappsPageStore.setState((prev) => ({ ...prev, dapps }));
};
